import { Button, Column, Row, Text } from '@atom-web/micros'
import { useMemo } from 'react'

import redirector from '../../../../utils/redirector'
import { faqSectionArr } from '../data'

export default ({ assetBg, bgSize }) => {
	const faqSection = useMemo(() => faqSectionArr, [])

	return (
		<Column
			gap={1}
			css={{
				marginBottom: '32px',
			}}
		>
			<Row justify="between">
				<Text
					as="h2"
					css={{
						fontSize: '24px',
						lineHeight: '32px',
						color: 'rgba(0,0,0,.9)',
						letterSpacing: '-0.03em',

						'@smMax': {
							fontSize: '17px',
						},
					}}
				>
					Frequently asked questions
				</Text>
				<Button
					outlined
					size="md"
					css={{
						color: 'rgba(44,47,66,.6)',
						border: '1px solid rgba(44,47,66,.6) !important',
						boxShadow: 'none',

						'&:hover': {
							opacity: 0.8,
						},
					}}
					onClick={() => redirector('/maldives-faq')}
				>
					View all
				</Button>
			</Row>

			<Row
				gap={6}
				css={{
					position: 'relative',
					width: '100%',
					overflow: 'scroll',
					minHeight: '200px',
					alignItems: 'center',
					overflowY: 'hidden',
					paddingLeft: '$1',
					zIndex: 2,
					'&::before': {
						position: 'absolute',
						content: '',
						top: 2,
						left: '12%',
						width: '240px',
						height: '200px',
						background: assetBg,
						backgroundPosition: '-377px -122px',
						backgroundSize: bgSize,
					},
				}}
			>
				{faqSection.map(({ text, bgPosition }, index) => (
					<Row
						key={'faq-' + index}
						css={{
							position: 'relative',
							alignItems: 'center',
							minWidth: '268px',
							maxWidth: '268px',
							minHeight: '158px',
							maxHeight: '158px',
							backgroundColor: '$white',
							borderRadius: '6px',
							backgroundClip: 'padding-box',
							boxShadow: '0 3px 15px rgb(0 0 0 / 10%)',
							cursor: 'pointer',

							'&::after': {
								position: 'absolute',
								content: '',
								bottom: 0,
								right: 0,
								width: '78px',
								height: '56px',
								background: assetBg,
								backgroundSize: bgSize,
								backgroundPosition: bgPosition,
							},
						}}
						onClick={() => redirector('/maldives-faq')}
					>
						<Text
							as="p"
							css={{
								fontSize: '18px',
								fontWeight: '$bolder',
								lineHeight: 1.33,
								letterSpacing: '-0.29px',
								padding: '24px',
							}}
						>
							{text}
						</Text>
					</Row>
				))}
			</Row>
		</Column>
	)
}
